import { useState } from "react";


interface MiniCardProps {
    name: string;
    value: number | string;
    icon: React.ReactNode;
    color?: string
    onClick?: () => void;
}

const MiniCard2: React.FC<MiniCardProps> = ({ name, value, icon, color, onClick }) => {

    return (
        <span onClick={onClick} className="mini-card2 p-2">
            <div style={{ color: color }}>{icon}</div> 
            <h6 className="mini-card-title">{name}</h6>
            <h5 style={{marginBottom: 2, color: color }}>{value}</h5>
        </span>
    );
};

export default MiniCard2;